import React from "react";

import { withShowIf } from "../../../with-show-if/with-show-If.component";

import { CardAvatarLeftoversProps } from "./card-avatar-leftovers.props";

export const CardAvatarLeftovers = withShowIf((props: CardAvatarLeftoversProps) => (
  <div className="card-avatars-leftover">{props.leftovers}</div>
));
